/* eslint-disable @typescript-eslint/no-empty-function */
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import React from 'react'
import { ReactComponent as NextArrowIcon } from '@site/images/swiper/rightArrow.svg'
import { ReactComponent as PrevArrowIcon } from '@site/images/swiper/leftArrow.svg'
import Slider from 'react-slick'
import { Container } from './styles'
import { CarouselArrowWrapper } from '@site/components/atoms/CarouselArrowWrapper/CarouselArrowWrapper'

const PeekCarouselSlider: React.FC<PeekCarouselSlider.Props> = ( {
  children,
  autoPlay = true,
  autoPlaySpeed = 8000,
  initialSlide = 0,
  arrows = false
} ): React.ReactElement => {
  const settings = {
    'autoplay': autoPlay,
    'autoplaySpeed': autoPlaySpeed,
    'infinite': true,
    initialSlide,
    'speed': 1000,
    'dots': false,
    arrows,
    'variableWidth': true,
    'swipeToSlide': true,
    'centerMode': true,
    'nextArrow':
      <CarouselArrowWrapper
        ArrowIcon={ NextArrowIcon }
        className=""
        onClick={ () => {} }
        style={{} as any}
      />,
    'prevArrow':
      <CarouselArrowWrapper
        ArrowIcon={ PrevArrowIcon }
        className=""
        onClick={ () => {} }
        style={{} as any}
      />,
    'responsive': [
      {
        'breakpoint': 992,
        'settings': {
          'arrows': false,
        }
      }
    ],
  }

  return (
    <Container>
      <Slider { ...settings }>
        {children}
      </Slider>
    </Container>
  )
}

namespace PeekCarouselSlider {
  export interface Props {
    children: React.ReactNode
    arrows?: boolean
    autoPlay?: boolean
    autoPlaySpeed?: number
    initialSlide?: number
  }
}

export default PeekCarouselSlider
